import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const RemindButton = styled.button`
  position: relative;
`;

export const Dot = styled.div`
  position: absolute;
  top: -3px;
  right: -5px;
  width: 0.9375rem;
  height: 0.9375rem;
  border: 3px solid var(--black-100);
  border-radius: 100%;
  background-color: var(--primary);
`;

export const ModalOverlay = styled.div`
  inset: 0;
  width: 100%;
  background-color: rgba(25, 25, 25, 0.75) !important;
  overflow: hidden;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  border: none !important;
  margin-left: auto;
  margin-top: 2rem;
  display: flex;
  background: var(--black-200) !important;
  width: 28rem;
  max-width: 28rem;
  max-height: 90vh;
  align-items: center;
  padding: 0;
  left: auto;
  bottom: auto;
`;

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid rgba(82, 82, 82, 0.24);
  width: 100%;
  padding: 1.5rem;

  h2 {
    font-family: DM Sans;
    font-size: 1.25rem;
    color: #fff;
  }

  button {
    background: transparent;
    font-family: Inter;
    font-size: 0.875rem;
    color: var(--white);

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const BodyContainer = styled.div`
  width: 100%;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 6rem;
    height: 6rem;
    margin-top: 2rem;
    margin-bottom: 1.5rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.5rem;
    font-family: IBM Plex Sans;
  }
`;

export const Text = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
  font-family: IBM Plex Sans;
`;
